import { render, staticRenderFns } from "./report-admin.vue?vue&type=template&id=150558fb&scoped=true&"
import script from "./report-admin.vue?vue&type=script&lang=js&"
export * from "./report-admin.vue?vue&type=script&lang=js&"
import style0 from "./report-admin.vue?vue&type=style&index=0&id=150558fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150558fb",
  null
  
)

export default component.exports